import React from 'react';
import useStyles from '../styles/styles';
import { makeStyles } from '@material-ui/core/styles';
type PeButtonProps = {
    readonly label: string;
    readonly name?: string;
    readonly type?: string;
    readonly disable?: boolean;
    readonly onClick?: any;
};

const useCustomStyles = makeStyles(theme => ({
    PEButton_button: {
        padding: '20px',
        border: 'none',
        borderRadius: '30px',
        width: '100%',
        fontSize: '15px',
        fontWeight: 500,
        transition: '0.1s',
        '&:hover': {
            transform: 'scale(1.1, 1.1)',
        },
        [theme.breakpoints.down('sm')]: {
            '&:hover': {
                transform: 'none',
            },
        },
    },
    PeButton_active: {
        backgroundImage: 'linear-gradient(135deg,#667eea 0,#764ba2 100%)',
        color: 'white',
        cursor: 'pointer',
    },
}));

const PeButton: React.FC<PeButtonProps> = props => {
    const classes = useStyles();
    const classesCustom = useCustomStyles();
    let classBtn = classes.disabled;
    switch (props.label) {
        case 'Start Over?':
            classBtn = classes.over;
            break;
        case 'Previous':
            classBtn = classes.prev;
            break;
        default:
            classBtn = classesCustom.PeButton_active;
            break;
    }

    return (
        <button
            disabled={props.disable}
            type={props.type === 'submit' ? 'submit' : 'button'}
            className={
                classesCustom.PEButton_button +
                ' ' +
                (props.disable ? classes.disabled : classBtn) +
                ' ' +
                (props.type !== 'submit' && classes.normalBtn)
            }
            onClick={props.onClick}
        >
            {props.label}
        </button>
    );
};

export default PeButton;
